<pfx-form-wrapper
  [form]="orderFormService.form"
  [(loading)]="loading"
  (submittedForm)="handleSubmit()"
  (canceledEdit)="handleCancel()"
>
  <form [formGroup]="orderFormService.form">
    <pfx-dropdown
      class="w-full"
      formControlName="settlementType"
      [options]="settlementTypeOptions"
      [label]="'settlement_type' | i18next: { ns: i18nNamespace }"
      [i18nNamespace]="i18nNamespace"
    ></pfx-dropdown>

    <pfx-multi-select
      class="w-full mt-4"
      formControlName="attendances"
      [options]="attendancesOptions()"
      [label]="'attendances' | i18next: { ns: i18nNamespace }"
      [i18nNamespace]="i18nNamespace"
    ></pfx-multi-select>

    <div
      formGroupName="period"
      class="flex gap-4 mt-4"
    >
      <pfx-date-picker
        class="w-full"
        formControlName="startAt"
        [label]="'startAt' | i18next: { ns: i18nNamespace }"
      ></pfx-date-picker>
      <pfx-date-picker
        class="w-full"
        formControlName="endAt"
        [label]="'endAt' | i18next: { ns: i18nNamespace }"
      ></pfx-date-picker>
    </div>

    <div class="flex gap-4 mt-4">
      <pfx-dropdown
        class="w-full"
        formControlName="organization"
        [options]="organizationOptions()"
        [label]="'organization' | i18next: { ns: i18nNamespace }"
        [i18nNamespace]="i18nNamespace"
      ></pfx-dropdown>
      <pfx-dropdown
        class="w-full"
        formControlName="caregiver"
        [options]="caregiverOptions()"
        [label]="'caregiver' | i18next: { ns: i18nNamespace }"
        [i18nNamespace]="i18nNamespace"
      ></pfx-dropdown>
    </div>

    <pfx-language-multi-select
      class="w-full mt-4"
      formControlName="languagePreference"
      [label]="'language_preference' | i18next: { ns: i18nNamespace }"
    ></pfx-language-multi-select>

    @if (
      orderFormService.form.controls.hasPetPreference.enabled ||
      orderFormService.form.controls.hasGenderPreference.enabled
    ) {
      <div class="flex gap-4 mt-4">
        @if (orderFormService.form.controls.hasGenderPreference.enabled) {
          <div class="flex-1">
            <pfx-checkbox
              formControlName="hasGenderPreference"
              [label]="'has_gender_preference' | i18next: { ns: i18nNamespace }"
            ></pfx-checkbox>

            @if (orderFormService.form.controls.genderPreference.enabled) {
              <pfx-gender-dropdown
                class="w-full mt-4"
                formControlName="genderPreference"
              ></pfx-gender-dropdown>
            }
          </div>
        }

        @if (orderFormService.form.controls.hasPetPreference.enabled) {
          <div class="flex-1">
            <pfx-checkbox
              formControlName="hasPetPreference"
              [label]="'has_pet_preference' | i18next: { ns: i18nNamespace }"
            ></pfx-checkbox>

            @if (orderFormService.form.controls.pets.enabled) {
              <pfx-text-input
                class="w-full mt-4"
                formControlName="pets"
                [label]="'pets' | i18next: { ns: i18nNamespace }"
              ></pfx-text-input>
            }
          </div>
        }
      </div>
    }

    @if (orderFormService.form.controls.frequency.enabled) {
      <h5>{{ 'planned_frequency' | i18next: { ns: i18nNamespace } }}</h5>

      <div
        formGroupName="frequency"
        class="flex flex-row gap-4"
      >
        <pfx-dropdown
          class="w-full flex-1"
          formControlName="rhythm"
          [options]="frequencyOptions"
          [label]="'rhythm' | i18next: { ns: i18nNamespace }"
        ></pfx-dropdown>
        <pfx-number-input
          class="flex-1"
          formControlName="visits"
          [label]="'visits' | i18next: { ns: i18nNamespace }"
        ></pfx-number-input>
        <pfx-number-input
          class="flex-1"
          formControlName="duration"
          [maxFractionDigits]="2"
          [label]="'duration' | i18next: { ns: i18nNamespace }"
        ></pfx-number-input>
      </div>
    }

    @if (orderFormService.form.controls.notes.enabled) {
      <pfx-textarea-input
        class="w-full mt-4"
        formControlName="notes"
        [readonly]="true"
        [rows]="10"
        [label]="'notes' | i18next: { ns: i18nNamespace }"
      ></pfx-textarea-input>
    }
  </form>
</pfx-form-wrapper>
